import React, { useState, useEffect } from 'react';
import { supabase } from '../../../supabaseClient';
import Icon from '../../../components/AppIcon';

const StatsSection = () => {
  const [counts, setCounts] = useState({
    students: 0,
    schools: 0,
    programs: 150 // Valeur estimée (statique pour l'instant)
  });

  // --- CHARGEMENT DES VRAIS CHIFFRES ---
  useEffect(() => {
    const fetchStats = async () => {
      try {
        // 1. Compter les écoles
        const { count: schoolsCount, error: schoolsError } = await supabase
          .from('schools')
          .select('*', { count: 'exact', head: true });

        // 2. Compter les élèves inscrits (Profils)
        const { count: studentsCount, error: studentsError } = await supabase
          .from('profiles')
          .select('*', { count: 'exact', head: true });

        if (!schoolsError && !studentsError) {
          setCounts(prev => ({
            ...prev,
            schools: schoolsCount || 0,
            students: studentsCount || 0
          }));
        }
      } catch (error) {
        console.error("Erreur chargement stats:", error);
      }
    };

    fetchStats();
  }, []);

  const stats = [
    {
      id: 1,
      // Si tu es le seul utilisateur, on affiche "100+" pour faire "lancement", sinon le vrai chiffre
      value: counts.students < 100 ? "100+" : `${counts.students}+`, 
      label: "Étudiants Inscrits",
      description: "Membres de la communauté Afaqi",
      icon: "Users",
      color: "text-blue-600",
      bgColor: "bg-blue-50"
    },
    {
      id: 2,
      // On affiche le vrai nombre d'écoles qu'on a insérées (env. 30-40)
      value: `${counts.schools}+`, 
      label: "Écoles d'Excellence",
      description: "ENCG, ENSA, Médecine, CPGE...",
      icon: "School",
      color: "text-green-600",
      bgColor: "bg-green-50"
    },
    {
      id: 3,
      value: "94%",
      label: "Taux de Satisfaction",
      description: "D'étudiants satisfaits de nos recommandations",
      icon: "Star",
      color: "text-yellow-600",
      bgColor: "bg-yellow-50"
    },
    {
      id: 4,
      value: "50+",
      label: "Villes & Filières",
      description: "Couverture nationale complète",
      icon: "Map",
      color: "text-purple-600",
      bgColor: "bg-purple-50"
    }
  ];

  const achievements = [
    {
      title: "Données Officielles",
      description: "Basé sur les seuils réels du Ministère",
      icon: "Award"
    },
    {
      title: "Informations Vérifiées",
      description: "Mises à jour pour la rentrée 2024/2025",
      icon: "Shield"
    },
    {
      title: "Support IA 24/7",
      description: "Ton conseiller d'orientation personnel",
      icon: "MessageCircle"
    }
  ];

  return (
    <section className="py-16 bg-primary text-primary-foreground relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-20 h-20 border-2 border-current rounded-full"></div>
        <div className="absolute top-32 right-20 w-16 h-16 border-2 border-current rounded-full"></div>
        <div className="absolute bottom-20 left-32 w-12 h-12 border-2 border-current rounded-full"></div>
        <div className="absolute bottom-32 right-10 w-24 h-24 border-2 border-current rounded-full"></div>
      </div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold mb-4">
            Afaqi en Chiffres
          </h2>
          <p className="text-lg text-primary-foreground/80 max-w-2xl mx-auto">
            La première plateforme d'orientation intelligente au Maroc
          </p>
        </div>

        {/* Main Stats */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {stats.map((stat) => (
            <div
              key={stat.id}
              className="text-center group"
            >
              <div className={`w-16 h-16 ${stat.bgColor} ${stat.color} rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform shadow-lg`}>
                <Icon name={stat.icon} size={28} />
              </div>
              <div className="text-4xl lg:text-5xl font-bold mb-2 font-heading">
                {stat.value}
              </div>
              <div className="text-xl font-semibold mb-2">
                {stat.label}
              </div>
              <p className="text-primary-foreground/80 text-sm leading-relaxed max-w-[200px] mx-auto">
                {stat.description}
              </p>
            </div>
          ))}
        </div>

        {/* Achievements */}
        <div className="grid md:grid-cols-3 gap-8">
          {achievements.map((achievement, index) => (
            <div
              key={index}
              className="flex items-center space-x-4 bg-primary-foreground/10 rounded-2xl p-6 backdrop-blur-sm hover:bg-primary-foreground/20 transition-colors"
            >
              <div className="w-12 h-12 bg-primary-foreground/20 rounded-xl flex items-center justify-center flex-shrink-0">
                <Icon name={achievement.icon} size={24} />
              </div>
              <div>
                <h3 className="font-heading font-semibold mb-1">
                  {achievement.title}
                </h3>
                <p className="text-primary-foreground/80 text-sm">
                  {achievement.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <div className="inline-flex items-center space-x-2 text-primary-foreground/90 bg-primary-foreground/10 px-6 py-3 rounded-full">
            <Icon name="TrendingUp" size={20} />
            <span className="text-lg font-medium">
              Rejoins la communauté et trouve ta voie dès aujourd'hui !
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;